import { render, staticRenderFns } from "./SponsorJoboffers.vue?vue&type=template&id=6f0286b8&scoped=true&"
import script from "./SponsorJoboffers.vue?vue&type=script&lang=js&"
export * from "./SponsorJoboffers.vue?vue&type=script&lang=js&"
import style0 from "./SponsorJoboffers.vue?vue&type=style&index=0&id=6f0286b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0286b8",
  null
  
)

export default component.exports